import angular from "angular";
import uiRouter from "angular-ui-router";
import onboarding1Component from "./onboarding1.component";

let onboarding1Module = angular
  .module("onboarding1", [uiRouter])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider.state("onboarding1", {
      url: "/onboarding1",
      template: "<onboarding1></onboarding1>",
      //params: { FirstName : null, LastName : null, CompanyName : null, Phone : null, Email : null, Password : null }
    });
  })

  .component("onboarding1", onboarding1Component);

export default onboarding1Module;



// WEBPACK FOOTER //
// ./client/app/components/onboarding1/onboarding1.js